import { render, staticRenderFns } from "./CompetitionNews.vue?vue&type=template&id=1dcaad51&scoped=true"
import script from "./CompetitionNews.vue?vue&type=script&lang=js"
export * from "./CompetitionNews.vue?vue&type=script&lang=js"
import style0 from "./CompetitionNews.vue?vue&type=style&index=0&id=1dcaad51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcaad51",
  null
  
)

export default component.exports